import { useMatch } from '@tanstack/react-location';
import { useTranslation } from '@frontend/i18n';
import { useAppScopeStore } from '@frontend/scope';
import { SettingsPage, SettingsPageLayout } from '@frontend/settings-ui';
import { AddPractitioner } from '../../components/ManagePractitionersV3/AddPractitioner';
import { MultiLocationManageServiceProviders } from '../ManageServiceProviders/MultiLocationManageServiceProviders';
import { ManagePractitionersV3Page } from './ManagePractitionersV3Page';

export const ManagePractitionersV3Settings = () => {
  const { t } = useTranslation('schedule-settings');
  const { params } = useMatch();
  const { getScopeName, selectedLocationIds } = useAppScopeStore();

  const locationId = (selectedLocationIds.length === 1 ? selectedLocationIds[0] : params?.locationId) ?? '';

  return (
    <SettingsPageLayout>
      <SettingsPage
        settingsLocationConfig={{
          chipLabel: getScopeName(locationId),
          isSingleLocation: !!locationId,
        }}
        title={t('Manage Providers')}
        subtitle={t(
          'Update biographical info, assign appointment types, and manage regular schedules to ensure availability for scheduling accuracy.'
        )}
        action={locationId && <AddPractitioner locationId={locationId} />}
      >
        {locationId ? <ManagePractitionersV3Page locationId={locationId} /> : <MultiLocationManageServiceProviders />}
      </SettingsPage>
    </SettingsPageLayout>
  );
};
